import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../pages/home.vue";
import Auth from "../Auth";
import WeddingList from "@/pages/WeddingList.vue";
import SharedWeddingList from "@/pages/SharedWeddingList.vue";
// import scrollBehavior from "./router.scrollBehavior.js";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { background: false },
  },
  {
    path: "/shop",
    name: "shop",
    component: () => import("../pages/products/shop.vue"),
    // beforeEnter: (to, from, next) => {
    //   if (Auth.authenticated()) {
    //     next("/");
    //   } else {
    //     next();
    //   }
    // },
  },
  {
    path: "/product/:slug",
    name: "productShow",
    component: () => import("../pages/products/product-show.vue"),
    // beforeEnter: (to, from, next) => {
    //   if (Auth.authenticated()) {
    //     next("/");
    //   } else {
    //     next();
    //   }
    // },
  },
  {
    path: "/partnerships",
    name: "partnerships",
    component: () => import("../pages/partnerships.vue"),
    // beforeEnter: (to, from, next) => {
    //   next("/coming-soon");
    // },
  },

  {
    path: "/about-us",
    name: "about-us",
    component: () => import("../pages/about-us.vue"),
    // beforeEnter: (to, from, next) => {
    //   next("/coming-soon");
    // },
  },
  {
    path: "/contact-us",
    name: "contact-us",
    component: () => import("../pages/contact-us.vue"),
    // beforeEnter: (to, from, next) => {
    //   next("/coming-soon");
    // },
  },
  {
    path: "/cart",
    name: "cart",
    component: () => import("../pages/cart/index.vue"),
  },
  {
    path: "/profile/wishlist",
    name: "wishlist",
    component: () => import("../pages/profile/wishlist.vue"),
    beforeEnter: (to, from, next) => {
      if (!Auth.authenticated()) {
        next("/");
      } else {
        next();
      }
    },
  },
  {
    path: "/compare",
    name: "compare",
    component: () => import("../pages/about-us.vue"),
    beforeEnter: (to, from, next) => {
      next("/coming-soon");
    },
  },

  {
    path: "/register",
    name: "register",
    component: () => import("../pages/register.vue"),
    beforeEnter: (to, from, next) => {
      if (Auth.authenticated()) {
        next("/");
      } else {
        next();
      }
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../pages/login.vue"),
    beforeEnter: (to, from, next) => {
      if (Auth.authenticated()) {
        next("/");
      } else {
        next();
      }
    },
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("../pages/profile/index.vue"),
    beforeEnter: (to, from, next) => {
      // next("/coming-soon");
      if (Auth.authenticated()) {
        next();
      } else {
        next("/");
      }
    },
  },

  {
    path: "/profile/account-details",
    name: "account-details",
    component: () => import("../pages/profile/account-details.vue"),
    beforeEnter: (to, from, next) => {
      // next("/coming-soon");
      if (Auth.authenticated()) {
        next();
      } else {
        next("/");
      }
    },
  },

  {
    path: "/profile/addresses",
    name: "account-addresses",
    component: () => import("../pages/profile/addresses.vue"),
    beforeEnter: (to, from, next) => {
      // next("/coming-soon");
      if (Auth.authenticated()) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/profile/orders",
    name: "orders",
    component: () => import("../pages/profile/orders.vue"),
    beforeEnter: (to, from, next) => {
      // next("/coming-soon");
      if (Auth.authenticated()) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/profile/orders/:orderId",
    name: "orders",
    component: () => import("../pages/profile/orders-show.vue"),
    beforeEnter: (to, from, next) => {
      // next("/coming-soon");
      if (Auth.authenticated()) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("../pages/logout.vue"),
    beforeEnter: (to, from, next) => {
      if (Auth.authenticated()) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/policies/refund-policy",
    name: "refund-policy",
    component: () => import("../pages/refund-policy.vue"),
  },
  {
    path: "/policies/privacy-policy",
    name: "privacy-policy",
    component: () => import("../pages/privacy-policy.vue"),
  },
  {
    path: "/policies/shipping-policy",
    name: "shipping-policy",
    component: () => import("../pages/shipping-policy.vue"),
  },
  {
    path: "/coming-soon",
    name: "comingsoon",
    component: () => import("../pages/coming-soon.vue"),
  },
  {
    path: "/checkout",
    name: "checkout",
    component: () => import("../pages/checkout.vue"),
    // beforeEnter: (to, from, next) => {
    //   if (Auth.authenticated()) {
    //     next();
    //   } else {
    //     next("/login");
    //   }
    // },
  },
  {
    path: "/thankyou/:orderId",
    name: "thankyou",
    component: () => import("../pages/thankyou.vue"),
    beforeEnter: (to, from, next) => {
      if (Auth.authenticated()) {
        next();
      } else {
        next("/login");
      }
    },
  },
  {
    path: "/profile/wedding-lists",
    name: "wedding-lists",
    component: WeddingList,
    meta: { requiresAuth: true },
  },
  {
    path: "/wedding-list/:shareCode",
    name: "shared-wedding-list",
    component: SharedWeddingList,
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
  // scrollBehavior,
});

export default router;
